export function formatTRXTypeEnumLabel(value) {
    if (!value) return ''

    return value
        .toString()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
}


export function formatDate (dateStr){
    if (!dateStr) return '-';
    try {
        const date = new Date(dateStr);
        const options = {
            year: 'numeric',
            month: 'short',   // Jan, Feb, etc.
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true      // 12 ساعته
        };
        return date.toLocaleString('en-US', options);
    } catch (err) {
        return dateStr;
    }
}


export function formatDateWithoutTime(dateStr) {
    if (!dateStr) return '-';
    try {
        const date = new Date(dateStr);
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // ماه 0-indexed
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    } catch (err) {
        return dateStr;
    }
}



export function formatDateTime(dateString) {
    if (!dateString) return '-';

    const date = new Date(dateString);

    const options = {
        month: 'short',       // Apr
        day: '2-digit',       // 06
        year: 'numeric',      // 2022
        hour: '2-digit',      // 11
        minute: '2-digit',    // 53
        hour12: true          // AM/PM
    };

    return new Intl.DateTimeFormat('en-US', options).format(date);
}